<template>
    <div class="sold-by-card" :class="classes">
        <span v-safe-html="title" />

        <div v-if="rating" class="sold-by-rating">
            Évaluation* :
            <Rating
                class="d-inline-flex"
                :average="rating"
                :rating-results-height="1.5"
                :font-size="0.875"
            />
        </div>

        <template v-if="infoLines.length > 0">
            <div
                v-for="info in infoLines"
                :key="info.label"
                class="alert-container alert-container-sm ob1-alert-nobackground"
                :class="alertClass(info.status)"
            >
                <p class="info-line alert mt-0 pb-0">
                    <span class="alert-icon" aria-hidden="true" />
                    <span class="ob1-alert-title">{{ info.label }}</span>
                </p>
            </div>
        </template>
    </div>
</template>

<script lang="ts">

import Rating from "../ob1/Rating.vue";
import {InfoLine, InfoLineStatus} from "./models/InfoLine";

export default {
    name: "SoldByCard",
    components: {Rating},
    props: {
        isLarge: {
            type: Boolean,
            default: false
        },
        soldByOrange: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        infoLines: {
            type: Array as () => InfoLine[],
            default: (): InfoLine[] => []
        },
        rating: {
            type: Number,
            default: null
        }
    },
    computed: {
        classes(): Record<string, boolean> {
            return {
                "sold-by-card-large" : this.isLarge,
                "sold-by-card-padded" : this.infoLines.length > 0 || this.rating !== null,
                "sold-by-orange" : this.soldByOrange,
                "sold-by-other" : !this.soldByOrange,
            };
        }
    },
    mounted() {
    },
    methods: {
        alertClass(status: InfoLineStatus): string {
            return status === InfoLineStatus.WARNING ? 'alert-warning' : 'alert-success'
        }
    }
}

</script>

<style lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.sold-by-card {

    --sold-by-other-accent: #9979C5;

    padding: px-to-rem(10) px-to-rem(15);
    border-left: px-to-rem(5) solid;
    font-size: px-to-rem(14);

    &.sold-by-orange {
        border-left-color: #F15E00;
    }

    .ob1-sosh &.sold-by-orange {
        border-left-color: #EB0450;
    }

    &.sold-by-other {
        border-left-color: var(--sold-by-other-accent);

        .ob1-rating .ob1-stars::after {
            color: var(--sold-by-other-accent);
        }
    }

    &.sold-by-card-large {
        font-size: px-to-rem(20);
        font-weight: bold;

        @media (max-width: 768px) {
            font-size: px-to-rem(14);
        }
    }

    &.sold-by-card-padded {
        padding: px-to-rem(10) px-to-rem(15);
    }

    @media (max-width: 768px) {
        padding-top: 0;
        padding-bottom: 0;
        border-width: px-to-rem(3);
    }

    .alert-container {
        margin-bottom: 0;

        .alert {
            margin-bottom: px-to-rem(5);
            margin-top: px-to-rem(5);

            &:last-child {
                margin-bottom: 0;
            }

            .alert-icon {
                font-size: px-to-rem(16);
            }

            .ob1-alert-title {
                font-weight: normal;
                font-size: px-to-rem(12);
            }
        }
    }

    .sold-by-rating {
        font-weight: bold;
        margin-top: px-to-rem(10);
    }

    .info-line {
        padding-top: px-to-rem(5);
    }
}

</style>
